/** Degradado CTA principal del sistema (catálogo, filtros, acciones). */
export const PRIMARY_CTA_GRADIENT = 'linear-gradient(to right, #06b6d4, #10b981)';

export const PRIMARY_CTA_GRADIENT_HOVER = 'linear-gradient(to right, #0891b2, #059669)';
